<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="合作老虎机" @back="goBack" /></span>
          <el-card style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel ref="CommonExcelRef" :import-p="'config:rewardTreasureEdit:import'" :export-p="'config:rewardTreasureEdit:export'" :import-method="importBaseCfg" :export-method="exportBaseCfg" />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template v-slot:default="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="开放等级" width="150" align="center">
                <template v-slot:default="scope">
                  <el-input v-model="scope.row.openLv" placeholder="开放等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="基础倍数" width="110">
                <template v-slot:default="{row}">
                  <el-input v-model.number="row.baseBet" placeholder="基础倍数" />
                </template>
              </el-table-column>
              <el-table-column label="入门奖励" width="150" align="center">
                <template v-slot:default="scope">
                  <el-input v-model="scope.row.joinReward" placeholder="入门基础奖励" />
                </template>
              </el-table-column>
              <el-table-column label="收集物数量" width="150" align="center">
                <template v-slot:default="scope">
                  <el-input v-model="scope.row.itemNum" placeholder="收集物数量" />
                </template>
              </el-table-column>
              <el-table-column label="兑换类型" width="150" align="center">
                <template v-slot:default="{row}">
                  <el-select v-model="row.exchangeType" style="width: 100%;" placeholder="请选择">
                    <el-option v-for="item in exchangeOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="兑换比例" width="150" align="center">
                <template v-slot:default="scope">
                  <el-input v-model="scope.row.exchangeRate" placeholder="兑换比例" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="下注">
                <template v-slot:default="{row}">
                  <el-select v-model="row.bets" style="width: 100%;" multiple placeholder="请选择">
                    <el-option v-for="item in betOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="转盘配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.proId">
                    <el-option v-for="item in list[2]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="大转盘配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.superProId">
                    <el-option v-for="item in list[3]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.rewardId">
                    <el-option v-for="item in list[4]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="商品配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.goodsId">
                    <el-option v-for="item in list[5]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <el-button v-permisaction="['config:rewardTreasureEdit:del']" size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button v-permisaction="['config:rewardTreasureEdit:add']" type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-permisaction="['config:rewardTreasureEdit:add']" type="primary" :disabled="isOnline === 1" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { getActivityList, updateActivityRewardConfData } from '@/api/config/activity-cfg'
import CommonExcel from '@/components/CommonExcel/index.vue'
import { downloadExcelMultiSheet } from '@/utils/excel'
export default {
  name: 'CooperateTreasureEdit',
  components: { CommonExcel },
  data() {
    return {
      list: [],
      baseList: [],
      groupsList: [{ name: '默认分组', id: 0 }],
      curClass: 'cooperate_treasure',
      rewardConf: [],
      isOnline: 0,
      betOptions: [
        { label: '倍数1', value: 1 },
        { label: '倍数2', value: 2 },
        { label: '倍数3', value: 3 },
        { label: '倍数5', value: 5 },
        { label: '倍数10', value: 10 },
        { label: '倍数20', value: 20 },
        { label: '倍数30', value: 30 }
      ],
      exchangeOptions: [
        { label: '金币', value: 14 },
        { label: '体力', value: 15 }
      ]
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.init()
  },
  methods: {
    init() {
      this.getActivity()
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], openLv: 0, joinReward: 0, itemNum: 1, exchangeRate: 0, bets: [], rewardId: 0, proId: 0, superProId: 0, goodsId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    handleSaveBase() {
      for (const i in this.baseList) {
        const val = this.baseList[i]
        if (!val.groupIds) {
          this.msgError('请选择分组')
          return
        }

        if (!val.proId) {
          this.msgError('请选择转盘')
          return
        }

        if (!val.superProId) {
          this.msgError('请选择大转盘')
          return
        }
      }
      const data = JSON.stringify(this.baseList)
      console.log('postData', data)
      updateActivityRewardConfData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActivity() {
      getActivityList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.baseList = res.data.list[0].reward_conf
          if (!this.baseList) {
            this.baseList = []
          }
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[4], proId: this.list[2], superProId: this.list[3], goodsId: this.list[5] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = '合作老虎机配置'
      const hearer = []
      const excelData = []
      const name = ['合作老虎机配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, proId: this.list[2], superProId: this.list[3], rewardId: this.list[4], goodsId: this.list[5] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', openLv: '开放等级', baseBet: '基础倍数', joinReward: '入门基础奖励', itemNum: '收集物数量', exchangeRate: '兑换比例', groupIds: { name: '用户分组', sub: [] }, bets: { name: '下注', sub: [] }, proId: '转盘配置', superProId: '大转盘配置', rewardId: '奖励配置', goodsId: '商品配置' })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    }
  }
}
</script>

<style scoped>
</style>
